import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { BACKEND_URL } from "../lib/config";

const AdminAuthContext = createContext(null);
const STORAGE_KEY = "smartdream_admin_auth";

const API = `${BACKEND_URL}/api/admin`;

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [token, setToken] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const parsed = JSON.parse(raw);
        setAdmin(parsed.admin);
        setToken(parsed.token);
      }
    } catch (e) {
      /* ignore */
    }
    setReady(true);
  }, []);

  const persist = (payload) => {
    if (payload) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
      setAdmin(payload.admin);
      setToken(payload.token);
    } else {
      localStorage.removeItem(STORAGE_KEY);
      setAdmin(null);
      setToken(null);
    }
  };

  const login = async (email, password) => {
    const res = await axios.post(`${API}/login`, { email, password });
    persist({ admin: res.data.admin, token: res.data.access_token });
    return res.data;
  };

  const logout = () => persist(null);

  const api = useCallback(
    (path, options = {}) => {
      const headers = {
        "Content-Type": "application/json",
        ...(options.headers || {}),
      };
      if (token) headers.Authorization = `Bearer ${token}`;
      return axios({
        url: `${API}${path}`,
        method: options.method || "GET",
        data: options.data,
        params: options.params,
        headers,
      }).then((r) => r.data);
    },
    [token]
  );

  return (
    <AdminAuthContext.Provider value={{ admin, token, ready, login, logout, api }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error("useAdminAuth must be used within AdminAuthProvider");
  return ctx;
}
